<template>
  <div class="page-container">
	<v-toolbar color="secondary" dark class="headline">
    	<v-toolbar-title v-if="mascota!=null">Visitas de {{mascota.nombre}}</v-toolbar-title>
	</v-toolbar>
	<v-container fluid>
        <v-layout row wrap>
			<v-flex xs12 sm6 md4 pt-1 pb-1 v-for="visita in visitas" :key="visita.id">
				<v-card>
				<v-container fluid grid-list-lg>
					<v-layout row wrap>
					<v-flex xs12>
						<div v-if="visita.editando!=true" class="headline visitas-titulo" >{{formatDate(visita.fecha)}}</div>
						<div v-if="visita.editando!=true" class="title visitas-titulo">{{getTipo(visita.tipo)}}</div>
						<div v-if="visita.editando!=true" class="subtitle-1 visitas-titulo">{{visita.detalle}}</div>

						<v-dialog v-if="visita.editando==true" :ref="'dialog_' + visita.id" v-model="modal" :return-value.sync="visita.fecha" persistent width="290px">
							<template v-slot:activator="{ on }">
								<v-text-field label="Fecha" class="headline" v-model="visita.fechaFormateada" prepend-icon="event" readonly v-on="on"></v-text-field>
							</template>
							<v-date-picker v-model="visita.fecha" scrollable>
								<v-spacer></v-spacer>
								<v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
								<v-btn text color="primary" @click="guardarFecha(visita,visita.fecha)">OK</v-btn>
							</v-date-picker>
						</v-dialog>
						<v-select v-if="visita.editando==true" :items="tipos" label="Tipo" item-text="descripcion" item-value="id" v-model="visita.tipo"></v-select>
						<v-text-field label="Detalle" :id="'txtVisita' + visita.id" class="subtitle-1 input-visitas"  v-if="visita.editando==true" v-model="visita.detalle"></v-text-field>
						<v-card-actions style="padding:0px;margin-top: 10px;justify-content:flex-end">
							<v-btn fab v-if="visita.editando==true" style="margin-right:10px!important" color="red" dark @click="cancelar(visita)"><v-icon class="fa-fab-icon">fa-times</v-icon></v-btn>
							<v-btn fab v-if="visita.editando==true" color="green" dark @click="aceptar(visita)"><v-icon class="fa-fab-icon">fa-check</v-icon></v-btn>
							<v-btn fab v-if="visita.editando!=true" style="margin-right:10px!important" :disabled="editando" color="red" dark @click="confirmarEliminar(visita)"><v-icon class="fa-fab-icon">fa-trash</v-icon></v-btn>
							<v-btn fab v-if="visita.editando!=true" :disabled="editando" color="blue" dark @click="setEditando(visita)"><v-icon class="fa-fab-icon">fa-pen</v-icon></v-btn>
						</v-card-actions>
					</v-flex>
					</v-layout>
				</v-container>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
	<v-btn color="green" :disabled="editando" dark fixed bottom right class="btn-very-large" @click="agregarNuevo()" fab>
		<v-icon>add</v-icon>
    </v-btn>
	<v-snackbar top :color="snackVisita" v-model="snackbar">{{ mensaje }}<v-btn color="black" small fab dark @click="snackbar = false"><v-icon class="fa-fab-icon">fa-times</v-icon></v-btn>
    </v-snackbar>
	<v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Eliminar Visita</span>
        </v-card-title>
        <v-card-text>
			¿Estás seguro que querés eliminar la visita?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="onCancelarEliminar()">No</v-btn>
          <v-btn color="blue darken-1" dark @click="onConfirmarEliminar()">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  	<div style="height:80px;width:1px;" v-if="$vuetify.breakpoint.smAndDown">&nbsp;</div>
  </div>
</template>

<script>
export default {
  name: "visitas",
  components: {},
  data() {
	return { mascota:null,visitas: [],snackbar:false,mensaje:'',snackVisita:'success',editando:false,dialog:false,aEliminar:null,modal:false,
		tipos:[
			{id:'CORTE',descripcion:'Corte'},
			{id:'BANO',descripcion:'Baño'},
			{id:'ARREGLO',descripcion:'Arreglo'},
			{id:'CORTE_Y_BANO',descripcion:'Corte y Baño'},
			{id:'CORTE_Y_ARREGLO',descripcion:'Corte y Arreglo'},
			{id:'BANO_Y_ARREGLO',descripcion:'Baño y Arreglo'},
			{id:'BANO_Y_CEPILLADO',descripcion:'Baño y Cepillado'},
			{id:'HIGIENICO',descripcion:'Higiénico'},
		]
	};
  },
  created() {
    this.obtenerElementos();
  },
  methods: {
	getTipo: function(idTipo){
		for(let i=0;i<this.tipos.length;i++){
			if (this.tipos[i].id==idTipo){
				return this.tipos[i].descripcion;
			}
		}
		return '';
	},
	guardarFecha: function(visita,fecha){
		visita.fechaFormateada = this.formatDate(fecha);
		this.$refs['dialog_' + visita.id][0].save(fecha);
	},
    obtenerElementos: function() {
		let mascotaId = this.$route.params['mascotaId'];
		this.$http.get(this.$root.mainUrl + 'api/visitas.php?m=' + mascotaId).then(result => {
			result.json().then(elem =>{
				this.mascota = elem.mascota;
				this.visitas = elem.visitas;
				this.visitas.sort(function(a,b){
					if (a.fecha>b.fecha){
						return -1;
					}
					else if(a.fecha<b.fecha){
						return 1;
					}
					return 0;
				});
				for(let i=0;i<this.visitas.length;i++){
					//this.$set(this.visitas[i], 'fecha', new Date(this.visitas[i].fecha));
					this.$set(this.visitas[i], 'fechaFormateada', this.formatDate(this.visitas[i].fecha));
					this.$set(this.visitas[i], 'editando', false);
				}
      		});
      	}, error => {
			//   console.error(error);
			this.showMessage('Ocurrió un error al obtener las visitas','error');
      	});
	},
	setEditando: function(visita){
		visita.descripcionBack = visita.descripcion;
		visita.tipoBack = visita.tipo;
		visita.fechaBack = visita.fecha;
		visita.fechaFormateadaBack = visita.fechaFormateada;
		visita.editando = true;
		this.editando = true;
		this.$nextTick(() => document.getElementById('txtVisita' + visita.id).focus());
	},
	cancelar: function(visita){
		visita.descripcion = visita.descripcionBack;
		visita.tipo = visita.tipoBack;
		visita.fecha = visita.fechaBack;
		visita.fechaFormateada = visita.fechaFormateadaBack;
		visita.editando = false;
		this.editando = false;
		if (visita.id==null){
			this.visitas.shift();
		}
	},
	confirmarEliminar: function(visita){
		this.aEliminar = visita;
		this.dialog = true;
	},
	onConfirmarEliminar: function(){
		this.dialog = false;
		this.eliminar(this.aEliminar);
	},
	onCancelarEliminar: function(){
		this.dialog = false;
		this.aEliminar = null;
	},
	eliminar: function(visita){
		visita.operacion = "ELIMINAR";
		this.$http.post(this.$root.mainUrl + 'api/visitas.php',visita).then(result => {
			result.json().then(elem =>{
				let idx=this.getIndex(visita);
				this.visitas.splice(idx, 1);
				this.snackbar = true;
				this.mensaje = "Visita eliminada correctamente";
				this.aEliminar = null;
			});
		}, error => {
			this.showMessage('Ocurrió un error al eliminar la visita','error');
			// console.error(error);
		});
	},
	aceptar: function(visita){
		if (visita.fecha==null || visita.fecha.trim()==''){
			this.showMessage('La fecha no puede estar vacía','error');
			return;
		}
		if (visita.tipo==null || visita.tipo.trim()==''){
			this.showMessage('El tipo no puede estar vacío','error');
			return;
		}
		visita.descripcionBack = null;
		visita.editando = false;
		visita.operacion = "GUARDAR";
		this.$http.post(this.$root.mainUrl + 'api/visitas.php',visita).then(result => {
			result.json().then(elem =>{
				if (elem.id!=null){
					visita.id=elem.id;
					this.showMessage('Visita creada correctamente','success');
				}
				else{
					this.showMessage('Visita actualizada correctamente','success');
				}
				this.editando = false;
			});
		}, error => {
			this.showMessage('Ocurrió un error al actualizar la Visita','error');
			// console.error(error);
		});
	},
	agregarNuevo: function(){
		this.editando = true;
		let visita = {editando:true,descripcion:'',id:null,fecha:null,mascota:this.mascota.id};
		this.visitas.unshift(visita);
		this.$vuetify.goTo(0);
	},
	getIndex: function(visita){
		for (let i=0;i<this.visitas.length;i++){
			if (this.visitas[i].id==visita.id){
				return i;
			}
		}
		return -1;
	},
	showMessage: function(message,style){
		this.snackVisita = style;
		this.mensaje = message;
		this.snackbar = true;
	},
	formatDate (date) {
        if (!date) return null

        let fecha = date.split(' ')[0];
        let fechaA = fecha.split('-');
        return fechaA[2] + '/' + fechaA[1] + '/' + fechaA[0];
      },
    parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return '${year}-${month.padStart(2, \'0\')}-${day.padStart(2, \'0\')}';
    },
  }
};
</script>
<style>
.page-container{
	padding-top:60px;
}
.fa-fab-icon{
	font-size: 1.5em!important;
}
.btn-very-large{
	height: 66px!important;
	width: 66px!important;
}
.btn-very-large i{
	font-size: 3.5em!important;
}
.visitas-titulo{
	min-height:40px;
}
.input-visitas{
	padding-top: 0px!important;
	padding-bottom: 0px!important;
	margin-top: 0px!important;
	margin-bottom: 0px!important;
}
.input-visitas .v-text-field__details{
	display: none;
}
</style>
